import { Card, Col, Descriptions, Divider, Row, Table, Tag, Typography } from 'antd'
import { CheckCircleOutlined, LeftOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import {useLocation, useNavigate, useParams } from 'react-router-dom';
import { VIEW_LEARNER_REPORT } from '../../../apis/apis';
import CulsightPageLoader from '../../../components/CulsightPageLoader';
const { Title, Text } = Typography;
function LearnerReport() {
  const Navigate = useNavigate();
  const location = useLocation();
  const { course_id, learner_id } = useParams();
  const [loader, setLoader] = useState(true);
   const [scorm, setscorm] = useState(false);
  const [course_name, set_course_name] = useState("")
  const [start_date, set_start_date] = useState("")
  const [course_progress, set_course_progress] = useState("")
  const [time_taken, set_time_taken] = useState("")
  const [learner_row, set_learner_row] = useState("")
  const [scorm_data, set_scorm_data] = useState({})
  const [table_data, set_table_data] = useState(false)
 
 
  const handleBack = () => {
    if (location.state?.from) {
      Navigate(location.state.from);
    } else {
      Navigate(-1);
    }
  };
 
 
  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "";
 
    seconds = Math.floor(seconds);
 
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
 
    let result = [];
    if (hrs > 0) result.push(`${hrs} hr${hrs > 1 ? "s" : ""}`);
    if (mins > 0) result.push(`${mins} min${mins > 1 ? "s" : ""}`);
    if (secs > 0 || result.length === 0) result.push(`${secs} sec${secs > 1 ? "s" : ""}`);
 
    return result.join(" ");
  };
 
 
 
  useEffect(() => {
    const LIST_API = async () => {
      setLoader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("course_id", atob(course_id));
      FORM_DATA.append("learner_id", atob(learner_id));
 
      const API_CALL = await VIEW_LEARNER_REPORT(FORM_DATA);
      if (API_CALL?.data?.status) {
        if (API_CALL.data?.data?.scrom_data) {
          set_scorm_data(API_CALL.data.data.scrom_data);
          set_course_name(API_CALL.data.data.course_name)
          set_learner_row(API_CALL.data.data.learner_row)
          set_start_date(API_CALL.data.data.start_date)
          set_course_progress(API_CALL.data?.data?.scorm_data?.progress_percentage)
          setscorm(true)
          setLoader(false);
        }else{
        set_table_data(API_CALL.data.data.chapters);
        set_course_name(API_CALL.data.data.course_name)
        set_learner_row(API_CALL.data.data.learner_row)
        set_start_date(API_CALL.data.data.start_date)
        set_course_progress(API_CALL.data.data.course_progress)
        set_time_taken(formatDuration(Number(API_CALL.data.data.time_taken)));
         setLoader(false);
        }
       
 
      }
     
 
    };
 
 
    LIST_API();
  }, [course_id, learner_id]);
 
  const columns = [
    {
      title: "Name",
      render: (text, record) => (
        <span>
          {record.name}
        </span>
      ),
    },
    {
      title: 'Chapter Status',
      dataIndex: 'chapter_status',
      key: 'chapter_status',
      render: (text, record) => <span>{record.chapter_status}</span>,
    },
    {
      title: 'Time Spent',
      render: (text, record) => (
        <span>
          {formatDuration(record.time_spend)}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <CheckCircleOutlined style={{ fontSize: "20px", color: "green", cursor: "pointer" }} />
      ),
    },
  ];
 
 
 
  return (
    <div className='lms-body'>
      <Card>
 
        {loader ? <>
          <CulsightPageLoader />  </> : <>
 
          <Row>
            <Col span={12}>
              <h2><span style={{ cursor: "pointer" }}
                onClick={handleBack}> <LeftOutlined /></span><span style={{ color: "#8c3add" }}>{course_name}</span> - Learner Report </h2>
            </Col>
          </Row>
          {scorm ? <>
         
           <Row gutter={[16, 16]} align="stretch">
            <Col span={12}>
              <Card style={{ textAlign: "left", marginBottom: "10px", height: "100%" }}>
                <h3 style={{ marginBottom: "10px" }}>Learner Details</h3>
                <p>Name: <b>{learner_row?.first_name} {learner_row?.last_name}</b></p>
                <p>Email: <b>{learner_row?.email}</b></p>
                <p>Phone: <b>{learner_row?.phone}</b></p>
                <p>Course: <b>{course_name}</b></p>
              </Card>
            </Col>
 
            <Col span={12}>
              <Card style={{ textAlign: "left", height: "100%" }}>
                <h3>Start Date</h3><span>{start_date}</span><br />
                <h3 style={{ marginTop: "15px" }}>Course Status</h3> <span>{scorm_data.lesson_status}</span><br />
                <h3 style={{ marginTop: "15px" }}>Course Progress</h3> <span>{scorm_data?.progress_percentage}%</span>
              </Card>
            </Col>
          </Row>
 
              <div style={{ padding: "16px 20px" }}>
              <Divider orientation="left">
                <Title level={5} style={{ margin: 0 }}>
                  Course Information
                </Title>
              </Divider>
 
              <Descriptions
                bordered
                size="middle"
                column={2}
                labelStyle={{ fontWeight: 600, width: 180 }}
              >
                <Descriptions.Item label="Lesson Status">
                   <Tag color="green">
                   {scorm_data?.lesson_status || "-"}
                  </Tag>
                 
                </Descriptions.Item>
 
                <Descriptions.Item label="Resume data">
                  <Tag color="green">
                    {scorm_data?.success_status || "Incomplete"}
                  </Tag>
                </Descriptions.Item>
 
                <Descriptions.Item label="Progress Percentage">
                  <Tag color="green">
                    {scorm_data?.progress_percentage }%
                  </Tag>
                </Descriptions.Item>
 
              </Descriptions>
            </div>
          </> : <>
         
           <Row gutter={[16, 16]} align="stretch">
            <Col span={12}>
              <Card style={{ textAlign: "left", marginBottom: "10px", height: "100%" }}>
                <h3 style={{ marginBottom: "10px" }}>Learner Details</h3>
                <p>Name: <b>{learner_row?.first_name} {learner_row?.last_name}</b></p>
                <p>Email: <b>{learner_row?.email}</b></p>
                <p>Phone: <b>{learner_row?.phone}</b></p>
                <p>Course: <b>{course_name}</b></p>
              </Card>
            </Col>
 
            <Col span={12}>
              <Card style={{ textAlign: "left", height: "100%" }}>
                <h3>Start Date</h3><span>{start_date}</span><br />
                <h3 style={{ marginTop: "15px" }}>Time Taken</h3> <span>{time_taken}</span><br />
                <h3 style={{ marginTop: "15px" }}>Course Progress</h3> <span>{course_progress}%</span>
              </Card>
            </Col>
          </Row>
 
 
          <Row style={{ marginTop: "15px" }}>
            <Col span={24}>
              <Table columns={columns} dataSource={table_data} pagination={false} />
            </Col>
          </Row>
          </> }
         
 
        </>}
 
 
      </Card>
    </div>
  )
}
 
export default LearnerReport
 
 